var _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgChart = function SvgChart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 130 66",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M129 1c-20.796 1.733-22.084 43.222-42.667 48-16.973 3.94-25.567-18.426-42.666-16C25.12 35.632 19.185 58.938 1 65h128V1Z",
    fill: "#D0F3E9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M129 1c-20.796 1.733-22.084 43.222-42.667 48-16.973 3.94-25.567-18.426-42.666-16C25.12 35.632 19.185 58.938 1 65h128V1Z",
    fill: "url(#Chart_svg__a)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 65c18.186-6.062 24.12-29.368 42.667-32 17.099-2.426 25.693 19.94 42.666 16C106.916 44.222 108.204 2.733 129 1",
    stroke: "#32C79D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Chart_svg__a",
    x1: 65,
    y1: 1,
    x2: 65,
    y2: 65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.641,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })))));
};
export default SvgChart;